module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/bg1-659f6ffd55024b3c7654901815d296d4.jpg";